import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type ArchiveGoalInput = {
  id: string;
  /** Partner the goal is bound to (null for org-wide goals). */
  partnerId: string | null;
};

// POST /api/admin/goals/:id/archive
//
// Sets is_archived = true on the row. Pessimistic — the archive toggle is
// an admin destructive-ish action, no need for optimism.
export function useArchiveGoal() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, ArchiveGoalInput>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/admin/goals/${id}/archive`, { method: "POST" }),
    onSuccess: (_data, { id, partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.goals.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.goals.detail(id) });
      if (partnerId) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.goals.forPartner(partnerId),
        });
        queryClient.invalidateQueries({
          queryKey: queryKeys.partners.detail(partnerId),
        });
      }
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to archive goal");
    },
  });
}
